import React from 'react';
import PropTypes from 'prop-types';
import Label from '../../components/Label';
import buildDisplaySubscription, { getDiversity, getLocation } from '../AdvancedAwarenessPage/utils';
import './styles.css';

export function subscriptionAsText(props) {
  const { data } = props;
  const built = buildDisplaySubscription(data);
  return (
    <React.Fragment>
      <span>{getLocation(built)}</span><br />
      <span styleName="diversity">{getDiversity(built)}</span><br />
    </React.Fragment>
  );
}
subscriptionAsText.propTypes = {
  data: PropTypes.object,
};

export function withErrorMessage(Component) {
  const wrapper = (props) => {
    const { error, ...rest } = props;
    return (
      <React.Fragment>
        <Component {...rest} />
        { error && <Label pointing="above" data-cy="tooltip-message">{error}</Label> }
      </React.Fragment>
    );
  };
  wrapper.propTypes = {
    error: PropTypes.any,
  };

  return wrapper;
}
